import zip from 'lodash/fp/zip'
export * from '../constants'

export const FETCH_KNOWLEDGE_TIERS = 'FETCH_KNOWLEDGE_TIERS'
export const TIERS = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
]
export const KNOWLEDGE_TIER_RANGES = [
  {
    to: 1,
  },
  {
    from: 1,
    to: 5,
  },
  {
    from: 5,
    to: 10,
  },
  {
    from: 10,
    to: 25,
  },
  {
    from: 25,
    to: 50,
  },
  {
    from: 50,
    to: 100,
  },
  {
    from: 100,
    to: 200,
  },
  {
    from: 200,
    to: 300,
  },
  {
    from: 300,
  },
]

export const TIER_LABELS = zip(TIERS, KNOWLEDGE_TIER_RANGES)
  .map(([tier, range]) =>
    !range.from ? `${tier} (0)` :
      !range.to ? `${tier} (${range.from}+)` :
      `${tier} (${range.from}-${range.to})`)



// WEBPACK FOOTER //
// ./src/pages/reports/knowledge-tiers/constants.ts